import { createClasses } from '../../theme/create-classes';

// ----------------------------------------------------------------------

export const scrollbarClasses = {
  root: createClasses('scrollbar__root'),
};
